import { isUndefined, object, keys, values, find, isEqual } from 'underscore';
import { PredicateUIType } from './constants';

export class Predicate {
  constructor({
    uiType = PredicateUIType.Editor,
    removable,
    property,
    operator,
    value,
    items,
  }) {
    this.uiType = uiType;
    this.removable = isUndefined(removable) ? true : removable;
    this.property = property;
    this.operator = operator;
    this.value = value;
    this.items = items;
  }

  getHumanizedValue() {
    if (this.items && this.items.length > 0) {
      return (find(this.items, item => isEqual(item.value, this.value)) || {}).text;
    }
    return this.value;
  }

  toQuery() {
    return object([this.property], [object([`$${this.operator}`], [this.value])]);
  }

  static fromQueryExpression({
    query,
    removable,
  }) {
    const property = keys(query)[0];
    const predicate = query[property];
    const operator = keys(predicate)[0].replace(/^\$/, '');
    const value = values(predicate)[0];

    return new Predicate({
      removable,
      property,
      operator,
      value,
    });
  }
}
